'use strict';
import angular from 'angular';
import CommonDataService from './common-data.service';
export default angular.module('eeComUiApp.common', [])
    .service('CommonDataService', CommonDataService)
    .name;
//# sourceMappingURL=index.js.map